module.exports = __webpack_public_path__ + "static/media/gif01.b325aad1.gif";